import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message, Button } from 'semantic-ui-react'
// import _find from 'lodash/find';
import _ from 'lodash';

import XLSX from 'xlsx'
import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries'

import general from '../../../modulos/general';
import ListaDe from '../../../components/funcionales/dirmayor/listade';
import ListaCi from '../../../components/funcionales/dirmayor/listaci';
import selciudad from '../../../functions/selciudad';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

// "use strict";

//dropdown PROCESOS DE FACT
const DetalleNivel1PF = props => {
//Se pone style={props.styles.input} de ultimo porque en firefox cuando se hace
//var miLista = document.getElementById("miLista3");
//=> para  miLista.options[miLista.selectedIndex].attributes[0]   trae el primer atributo y no trae
//dato1 como en chrome
  return (
    <option dato1={props.elemento.observaciones} dato2={props.elemento.codProcFact}
        value={props.elemento._id} style={props.styles.input}>{props.elemento.descrDpto} ={">"} {props.elemento.nombreCiudad} ={">"} {props.elemento.descrClaseServ} ={">"} FACTURAS: {props.elemento.factInicial} A {props.elemento.factFinal} ={">"} CICLO: {props.elemento.cicloFact}</option>
  )
};

const ListaPF = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1PF styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="proceso" id="miListaPF"  onChange={(ev)=>handleChange(ev)}>
        <option style={styles.input} value="">Todos...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown PROCESOS DE FACT

//dropdown CLASES
const DetalleNivel1 = props => {
  return (
    <option dato1={props.elemento.codigoClaseServ} value={props.elemento._id} style={props.styles.input}>{props.elemento.descrClaseServ}</option>
  )
};

const Lista = ({styles, handleLista4, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="clase" id="miLista4" onChange={handleLista4} onClick={(ev)=>handleChange(ev)}>
        <option style={styles.input} value="">Todas...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown CLASES

//dropdown RANGOS FACTURACION
const DetalleRangoNivel1 = props => {
  // console.log(props.elemento)
  return (
    <option dato1={props.elemento._id} value={props.elemento.proxFact+':'+props.elemento.factInicial+':'+props.elemento.factFinal} style={props.styles.input}>{props.elemento.prefijo} {props.elemento.factInicial} - {props.elemento.factFinal}</option>
  )
};

const ListaRango = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleRangoNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="rango" id="miLista3" onChange={(ev)=>handleChange(ev)}>
        <option value="">Todos...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown RANGOS DE FACTURACION

//Lista de gestion recaudo
const FactDet = ({elemento, filtroCiu, opciones1, permiteOpcion1, permiteOpcion2}) => {
  // console.log("cc", opciones1, permiteOpcion1, permiteOpcion2)
  if(opciones1==="opcion4"&&permiteOpcion1){
    return(
      <tr className=''>
      <td className=''>{elemento.fechaFact.substr(0, 10)}</td>
      <td className=''>{elemento.numeroFra}</td>
      {filtroCiu &&
        <td className=''>{elemento.nombreCiudad}</td>
      }
      <td className=''>{elemento.contrato}</td>
      <td className=''>{elemento.nombreCliente}</td>
      <td className=''>{elemento.apellidoCliente}</td>
      <td className=''>{elemento.codigoTipoDoc}</td>
      <td className=''>{elemento.numeroDoc}</td>
      <td className=''>{elemento.tipoGen}</td>
      <td className=''>{elemento.agno + '-' + elemento.mes}</td>
      <td className='right aligned'>{Intl.NumberFormat('de-DE').format(elemento.valorAntesImptos)}</td>
      <td className='right aligned'>{Intl.NumberFormat('de-DE').format(elemento.valorFacturado - elemento.valorAntesImptos)}</td>
      <td className='right aligned'>{Intl.NumberFormat('de-DE').format(elemento.valorFacturado)}</td>
      <td className='right aligned'>{Intl.NumberFormat('de-DE').format(elemento.valorFactura - elemento.valorFacturado)}</td>
      <td className='right aligned'>{Intl.NumberFormat('de-DE').format(elemento.valorFactura)}</td>
      </tr>
    )
  }
  if(opciones1==="opcion4"&&permiteOpcion2){
    return(
      <tr className=''>
      <td className=''>{elemento.fechaFact.substr(0, 10)}</td>
      <td className=''>{elemento.numeroFra}</td>
      {filtroCiu &&
        <td className=''>{elemento.nombreCiudad}</td>
      }
      <td className=''>{elemento.contrato}</td>
      <td className=''>{elemento.nombreCliente}</td>
      <td className=''>{elemento.apellidoCliente}</td>
      <td className=''>{elemento.tipoGen}</td>
      <td className=''>{elemento.agno + '-' + elemento.mes}</td>
      <td className='right aligned'>{Intl.NumberFormat('de-DE').format(elemento.valorAntesImptos)}</td>
      <td className='right aligned'>{Intl.NumberFormat('de-DE').format(elemento.valorFacturado - elemento.valorAntesImptos)}</td>
      <td className='right aligned'>{Intl.NumberFormat('de-DE').format(elemento.valorFacturado)}</td>
      </tr>
    )
  }
  if(opciones1==="opcion5"){
    return(
      <tr className=''>
      <td className=''>{elemento.fechaFact.substr(0, 10)}</td>
      <td className=''>{elemento.numeroFra}</td>
      {filtroCiu &&
        <td className=''>{elemento.nombreCiudad}</td>
      }
      <td className=''>{elemento.contrato}</td>
      <td className=''>{elemento.nombreCliente}</td>
      <td className=''>{elemento.apellidoCliente}</td>
      <td className=''>{elemento.descrEstrato}</td>
      <td className=''>{elemento.tipoGen}</td>
      <td className=''>{elemento.agno + '-' + elemento.mes}</td>
      <td className=''>{elemento.descrClaseServ}</td>
      <td className=''>{elemento.descripcionServicio}</td>
      <td className='right aligned'>{Intl.NumberFormat('de-DE').format(elemento.valorAntesImptos)}</td>
      <td className='right aligned'>{Intl.NumberFormat('de-DE').format(elemento.valorFactura)}</td>
      <td className='right aligned'>{Intl.NumberFormat('de-DE').format(elemento.valorFacturado)}</td>
      </tr>
    )
  }
  if(permiteOpcion1&&opciones1==="opcion6"){
    return(
      <tr className=''>
      <td className=''>{elemento.descrClaseServ}</td>
      <td className=''>{elemento.descripcionServicio}</td>
      <td className=''>{elemento.concepto}</td>
      <td className='right aligned'>{Intl.NumberFormat('de-DE').format(elemento.valor)}</td>
      </tr>
    )
  }
  if(permiteOpcion2&&opciones1==="opcion6"){
    return(
      <tr className=''>
        <td className=''>{elemento.descrClaseServ}</td>
        <td className=''>{elemento.descripcionServicio}</td>
        <td className='right aligned'>{Intl.NumberFormat('de-DE').format(elemento.valorSF)}</td>
        <td className='right aligned'>{Intl.NumberFormat('de-DE').format(elemento.valorIF)}</td>
        <td className='right aligned'>{Intl.NumberFormat('de-DE').format(elemento.valorTot)}</td>
      {/* <td className='right aligned'>{Intl.NumberFormat('de-DE').format(elemento.totServ)}</td> */}
      </tr>
    )
  }
  if(permiteOpcion1&&opciones1==="opcion7"){
    // let valorImptos = parseInt(elemento.valorFacturado, 10) - parseInt(elemento.valorAntesImptos, 10)
    return(
      <tr className=''>
        <td className=''>{elemento.contrato}</td>
        <td className=''>{elemento.codigoTipoDoc}</td>
        <td className=''>{elemento.numeroDoc}</td>
        <td className=''>{elemento.apellidoCliente}</td>
        <td className=''>{elemento.nombreCliente}</td>
        <td className=''>{elemento.razonSocial}</td>
        <td className=''>{elemento.direccionCli}</td>
        <td className=''>{elemento.nombreBarrio}</td>
        <td className=''>{elemento.codigoDpto}</td>
        <td className=''>{elemento.codigoCiudad}</td>
        <td className=''>{elemento.descrEstrato}</td>
        <td className=''>{elemento.descrClaseServ}</td>
        <td className='right aligned'>{general.formatNum(elemento.valorAntesImptos.toString())}</td>
        <td className='right aligned'>{general.formatNum(elemento.valorImptos.toString())}</td>
        <td className='right aligned'>{general.formatNum(elemento.valorFacturado.toString())}</td>
      </tr>
    )
  }
  if(permiteOpcion1&&opciones1==="opcion8"){
    // let valorImptos = parseInt(elemento.valorFacturado, 10) - parseInt(elemento.valorAntesImptos, 10)
    return(
      <tr className=''>
        <td className=''>{elemento.descrClaseServ}</td>
        <td className=''>{elemento.descrSubclaseServ}</td>
        <td className=''>{elemento.descripcionServicio}</td>
        <td className='right aligned'>{general.formatNum(elemento.valorProceso.toString())}</td>
        <td className='right aligned'>{general.formatNum(elemento.valorMes.toString())}</td>
      </tr>
    )
  }
  if(permiteOpcion2&&opciones1==="opcion7"){
    return(
      <tr className=''>
        <td className=''>{elemento.descrClaseServ}</td>
        <td className='right aligned'>{Intl.NumberFormat('de-DE').format(elemento.valorAntesImptos)}</td>
        <td className='right aligned'>{Intl.NumberFormat('de-DE').format(elemento.valorFacturado)}</td>
        <td className='right aligned'>{Intl.NumberFormat('de-DE').format(elemento.valorAntesImptos + elemento.valorFacturado)}</td>
      </tr>
    )
  }
};

const ListaFact = ({list, opciones1, filtroCiu, permiteOpcion1, permiteOpcion2}) => {
  const nivel1Detalle = list.map((elemento, i) => <FactDet elemento={elemento} key={i} filtroCiu={filtroCiu}
      opciones1={opciones1} permiteOpcion1={permiteOpcion1} permiteOpcion2={permiteOpcion2}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};
//Fin lista de gestion recaudo
  

let fechaHoy = new Date()
let fechaIni = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-01'
fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())

// const argsBuscarCL = {numDocum: 2027}
let argsBuscarFact = {tipoqry: `[{$match: {fechaFact: { $gte: new Date("2019-04-07"), $lte: new Date("2019-04-07") }}},{$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}}]`}
let argsBuscarFactGr = {tipoqry: `[{$match: {fechaFact: { $gte: new Date("2019-04-07"), $lte: new Date("2019-04-07") }}}]`}

class RtesFact2 extends React.Component {
  state={argsDocum: {_id: "Todos...", desde: fechaIni, hasta: fechaHoy, desdeF: fechaIni, hastaF: fechaHoy,
          descrDpto: "Todos...", nombreCiudad: "Todas..."},
        opciones: "opcion1", opciones1: "opcion4", argsSelDpto: this.props.argsSelDpto, listRtes: [],
        confirmaAct: false, errors: [], totalF: 0, totalAI: 0, totalI: 0, totalFdo: 0, totalSA: 0, totalEF: 0, totUsu: 0,
        verEnPantalla: false}

  handleChange = (ev) => {
    const argsDocum = this.state.argsDocum
    // console.log(ev.target.name)
    // console.log(argsDocum)
    let listRtes = []
    this.setState({listRtes, totalF: 0, totalAI: 0, totalI: 0, totalFdo: 0, totalSA: 0, totalEF: 0, totUsu: 0})
    this.setState({verEnPantalla: false})

    if(ev.target.name==="opciones"||ev.target.name==="opciones1"){
      if(ev.target.checked===true){
        if(ev.target.name==="opciones"){
          this.setState({opciones: ev.target.value})
        }else{
          this.setState({opciones1: ev.target.value})
        }
      }
      if(ev.target.value==="opcion6"||ev.target.value==="opcion7"||ev.target.value==="opcion8"){
        let argsSelDpto = this.state.argsSelDpto
        argsSelDpto.descrClaseServ = "Todas..."
        this.setState({argsSelDpto})
      }
    }else{  
      if(ev.target.name==="proceso"){
        // let miLista = document.getElementById("miLista");
        // // this.setState({observaciones: miLista.options[miLista.selectedIndex].attributes[0].value})
      }else{
        if(ev.target.name === "rango"){
          let miLista = document.getElementById("miLista3");
          // console.log(miLista.options[miLista.selectedIndex].attributes[0])
          // console.log(miLista.options[miLista.selectedIndex].attributes[0].value)
          let _id = miLista.options[miLista.selectedIndex].attributes[0]?miLista.options[miLista.selectedIndex].attributes[0].value:""
          if(_id){
            argsDocum['_id'] = _id
          }else{
            argsDocum['_id'] = "Todos..."
          }
        }else{
          argsDocum[ev.target.name] = ev.target.value
        }
      }
    }
    // console.log(argsDocum)
    this.setState({argsDocum});
  }

  handleSubmit = async (ev, argsDocum, opciones, opciones1, filtroCiu)=>{
    // console.log(ev.target.name)
    // console.log(argsDocum)
    let targetName = ev.target.name
    document.body.style.cursor = 'wait'

    if(targetName==="pantalla"||targetName==="pdf"){
      this.setState({verEnPantalla: true})
    } 
    if((targetName==="pantalla"&&this.state.listRtes.length===0)||this.state.listRtes.length===0){
      // if((targetName==="pantalla"&&this.state.listRtes.length===0)){
      // if(targetName==="pantalla"){
        // document.body.style.cursor = 'wait'
  
    // if(targetName==="pantalla"){
    // let fechaHoy = new Date()
    // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
    let argsUpd
    let errors = []
    // if(!this.props.allClientes.allClientes||!this.props.allFactRtes.allFactRtes){
    //   errors.push({path: "Facturas", message: "Proceso de cargue de la información, por favor espere un momento..."});
    // }
    if(!this.props.allFactRtes.allFactRtes){
      errors.push({path: "Facturas", message: "Proceso de cargue de la información, por favor espere un momento..."});
    }
    if(!argsDocum.desde){
      errors.push({path: "Desde", message: "Debe seleccionar la fecha inicial de facturas causadas"});
    }
    if(!argsDocum.hasta){
      errors.push({path: "Hasta", message: "Debe seleccionar la fecha final de facturas causadas"});
    }
    // if(!argsDocum.desdeF){
    //   errors.push({path: "Desde", message: "Debe seleccionar la fecha inicial de procesos de facturación"});
    // }
    // if(!argsDocum.hastaF){
    //   errors.push({path: "Hasta", message: "Debe seleccionar la fecha final de procesos de facturación"});
    // }
  // console.log(console.log(this.props.allFactRtes.allFactRtes))
    // console.log(argsDocum)
    this.setState({errors})
    if(errors.length===0){
      let argsBuscarFact=""

      // const argsBuscarFact = {fechaMov: { $gte: argsDocum.desdeF, $lte: argsDocum.hastaF },
      //   fechaFact: { $gte: argsDocum.desde, $lte: argsDocum.hasta }}
        // tipoGen: "proceso"}

      argsBuscarFact += `fechaFact: { $gte: new Date('${argsDocum.desde}'), $lte: new Date('${argsDocum.hasta}') }`

      if(opciones==="opcion2"){
        argsBuscarFact += `, 'tipoGen': 'mes'`
      }
      if(opciones==="opcion3"){
        argsBuscarFact += `, 'tipoGen': 'proceso'`
      }

      if(this.props.argsSelDpto.descrDpto===undefined||this.props.argsSelDpto.descrDpto==="Todos..."){
        // clientesLis = clientesLis
      }else{
        if(this.props.argsSelDpto.nombreCiudad===undefined||this.props.argsSelDpto.nombreCiudad==="Todas..."){
          argsBuscarFact += `, 'descrDpto': '${this.props.argsSelDpto.descrDpto}'`
        }else{
          argsBuscarFact += `, 'descrDpto': '${this.props.argsSelDpto.descrDpto}',
          'nombreCiudad': '${this.props.argsSelDpto.nombreCiudad}'`
        }
      }

      // const argsBuscarFact = {fechaFact: { $gte: argsDocum.desde, $lte: argsDocum.hasta }}

      // console.log(argsDocum._id)

      let miLista = document.getElementById("miListaPF");
      // console.log(miLista.options[miLista.selectedIndex].text)
      argsBuscarFact += `, `
      if(miLista.options[miLista.selectedIndex].text!=="Todos..."){
        // argsBuscarFact.codProcFact = miLista.options[miLista.selectedIndex].attributes[1].value

        argsBuscarFact += `'codProcFact': '${miLista.options[miLista.selectedIndex].attributes[1].value}'`
      }else{
        if(argsDocum._id!=="Todos..."){
          //Se selecciona un rango y todos los procesos de fact
          let argsBuscarFactPF = `'${argsDocum._id}'`  //para incluir los de tipoGen="mes" del rango selecc
          //array de los procesos de fact del rango selecc
          for(let i=0; i<miLista.options.length; i++){
            if(miLista.options[i].label!=="Todos..."){
              if(argsBuscarFactPF){argsBuscarFactPF += `, `}
              argsBuscarFactPF += `'${miLista.options[i].attributes[1].value}'`
            }
          }
          // console.log(argsBuscarFactPF)
          if(argsBuscarFactPF){
            argsBuscarFact += `codProcFact: { $in: [${argsBuscarFactPF}] }`
          }
        }else{
          argsBuscarFact += `'codProcFact': {$ne: 'ANULADA'}`
        }
      }

      let clientesFact = [], totUsu = 0
      if(this.state.opciones1==="opcion6"){
        argsBuscarFact = '{' + argsBuscarFact + '}'
        let tipoqry = `[{$match: ${argsBuscarFact}},`
        if(this.props.argsSelDpto.descrClaseServ&&this.props.argsSelDpto.descrClaseServ!=="Todas..."){
          tipoqry += ` {"$unwind":"$detalleFact"},`
          tipoqry += `{$match: {'detalleFact.descrClaseServ': '${this.props.argsSelDpto.descrClaseServ}'}},`    
        }
        let argsBuscarFactUsu = {}
        if(this.props.permiteOpcion1){
          argsBuscarFactUsu = {tipoqry: `${tipoqry}
            {$group: {_id: '$numeroFra'}},
            {$project: {'numeroFra': '$numeroFra'}},
            {$group: {_id: '$numeroFra', count: { $sum: 1 }}},
            {$project: {_id: 0, totServ: {$toInt: '$count'}}}
          ]`}
        }else{
          argsBuscarFactUsu = {tipoqry: `${tipoqry}
            {$group: {_id: '$contrato'}},
            {$project: {'contrato': '$contrato'}},
            {$group: {_id: '$contrato', count: { $sum: 1 }}},
            {$project: {_id: 0, totServ: {$toInt: '$count'}}}
          ]`}
        }
        // console.log(argsBuscarFactUsu)
        if(argsBuscarFactUsu){
          let {data} = await this.props.allFactRtesGroup.refetch(argsBuscarFactUsu)
          clientesFact = await data.allFactRtesGroup
          if(clientesFact.length>0){
            totUsu = clientesFact[0].totServ
          }
        }
        // console.log(totUsu)

        tipoqry = `[{$match: ${argsBuscarFact}},
                        {$unwind:"$detalleFact"},`
        if(this.props.argsSelDpto.descrClaseServ&&this.props.argsSelDpto.descrClaseServ!=="Todas..."){
          tipoqry += `{$match: {'detalleFact.descrClaseServ': '${this.props.argsSelDpto.descrClaseServ}'}},`    
        }

        if(this.props.permiteOpcion1){
          argsBuscarFact = {tipoqry: `${tipoqry}
          {$project: {'descrClaseServ': '$detalleFact.descrClaseServ',
            'descripcionServicio': '$detalleFact.descripcionServicio',
            'concepto': '$detalleFact.concepto',
            'valorSF': {
              $let: {
                vars: {valorTipo: '$detalleFact.valor', tipo: '$detalleFact.tipo'},
                in: { $cond: { if: { $eq: [ "$$tipo", "SF" ] }, then: "$$valorTipo", else: 0 } }
              }
            },
            'valorIF': {
                $let: {
                  vars: {valorTipo: '$detalleFact.valor', tipo: '$detalleFact.tipo'},
                  in: { $cond: { if: { $eq: [ "$$tipo", "IF" ] }, then: "$$valorTipo", else: 0 } }
              }
            }
          }},
          {$group: {_id: {descrClaseServ: '$descrClaseServ', descripcionServicio: '$descripcionServicio',
            concepto: '$concepto'}, valorSF: {$sum: '$valorSF'}, valorIF: {$sum: '$valorIF'}}},
          {$sort: {_id: 1}},
          {$project: {_id: 0, 'descrClaseServ': '$_id.descrClaseServ', 
            'descripcionServicio': '$_id.descripcionServicio', concepto: '$_id.concepto', 
            valorSF: {$toLong: '$valorSF'}, valorIF: {$toLong: '$valorIF'}}}
        ]`}
        }else{
          argsBuscarFact = {tipoqry: `${tipoqry}
            {$project: {'numeroFra': 1,
                  'descrClaseServ': '$detalleFact.descrClaseServ',
                  'descripcionServicio': '$detalleFact.descripcionServicio',
                  'valorSF': {
                      $let: {
                          vars: {valorTipo: '$detalleFact.valor', tipo: '$detalleFact.tipo'},
                          in: { $cond: { if: { $eq: [ "$$tipo", "SF" ] }, then: "$$valorTipo", else: 0 } }
                      }
                  },
                  'valorIF': {
                      $let: {
                          vars: {valorTipo: '$detalleFact.valor', tipo: '$detalleFact.tipo'},
                          in: { $cond: { if: { $eq: [ "$$tipo", "IF" ] }, then: "$$valorTipo", else: 0 } }
                      }
                  }
                }
            },
            {$group: {_id: {numeroFra: '$numeroFra', descrClaseServ: '$descrClaseServ', descripcionServicio: '$descripcionServicio'},
                      valorSF: {$sum: '$valorSF'}, valorIF: {$sum: '$valorIF'}}},
            {$unwind:"$_id"},
            {$group: {_id: {descrClaseServ: '$_id.descrClaseServ', descripcionServicio: '$_id.descripcionServicio'}, cuenta: { $sum: 1 },
                      valorSF: {$sum: '$valorSF'}, valorIF: {$sum: '$valorIF'}}},
            {$unwind:"$_id"},
            {$sort: {_id: 1}},
            {$project: {_id: 0, totServ: {$toInt: '$cuenta'}, 'descrClaseServ': '$_id.descrClaseServ',
                      'descripcionServicio': '$_id.descripcionServicio', valorSF: {$toLong: '$valorSF'}, valorIF: {$toLong: '$valorIF'}}}
          ]`}
        }
        // console.log(argsBuscarFact)
        if(argsBuscarFact){
          let {data} = await this.props.allFactRtesGroup.refetch(argsBuscarFact)
          clientesFact = await data.allFactRtesGroup
          // console.log(clientesFact)
        }
      }else{
        // console.log(this.props.permiteOpcion1, this.props.permiteOpcion2, this.state.opciones1)
        argsBuscarFact = '{' + argsBuscarFact + '}'
        if((this.state.opciones1!=="opcion7"&&this.state.opciones1!=="opcion8")||(this.props.permiteOpcion2&&this.state.opciones1==="opcion7")){
          if(this.props.permiteOpcion2&&this.state.opciones1==="opcion7"){
            //En el ultimo $project se pone _id: '$valorSF' para tener un _id unico
            //Si el _id no es unico => se repite el primer docummento
            let tipoqry = `[{$match: ${argsBuscarFact}},
              {"$unwind": "$detalleFact"},
              {$project: {_id: 0, numeroFra: 1, descrClaseServ: '$detalleFact.descrClaseServ',
                  descripcionServicio: '$detalleFact.descripcionServicio',
                  valorImpto: {$cond: { if: { $eq: [ '$detalleFact.tipo', 'SF' ] },
                        then: {valorSF: '$detalleFact.valor', valorIF: 0},
                        else: {valorSF: 0, valorIF: '$detalleFact.valor'}
                  }}
              }},
              {$group: {_id: {numeroFra: '$numeroFra', descrClaseServ: '$descrClaseServ', descripcionServicio: '$descripcionServicio'},
                  valorSF: {$sum: '$valorImpto.valorSF'}, valorIF: {$sum: '$valorImpto.valorIF'}}},
              {$project: {descrClaseServ: '$_id.descrClaseServ', valorSF: 1, valorIF: 1, _id: 0,
                  valorImptos: {$cond: { if: { $eq: [ '$valorIF', 0 ] },
                        then: {descrImpto: "Impuesto 0"},
                        else: {descrImpto: "Impuesto dieferente a 0"}
                  }}
              }},
              {$group: {_id: {descrRecurso: '$descrClaseServ', numeroFra: '$valorImptos.descrImpto'},
                  valorSF: {$sum: '$valorSF'}, valorIF: {$sum: '$valorIF'}}},
              {$project: {_id: '$valorSF', descrRecurso: '$_id.descrRecurso', numeroFra: '$_id.numeroFra',
                  valorAntesImptos: '$valorSF', valorFacturado: '$valorIF'}},`

            if(this.props.argsSelDpto.descrClaseServ&&this.props.argsSelDpto.descrClaseServ!=="Todas..."){
              tipoqry += `{$match: {'descrRecurso': '${this.props.argsSelDpto.descrClaseServ}'}},`    
            }

            tipoqry += `{$sort: {descrRecurso: 1, numeroFra: 1}}]`

            argsBuscarFact = {tipoqry: tipoqry}
          }else{
            if(this.props.permiteOpcion1&&opciones1==="opcion5"){
              let tipoqry = `[{$match: ${argsBuscarFact}},`
              argsBuscarFact = {tipoqry: `${tipoqry}
                {$unwind: "$detalleFact"},
                {$project: {contrato: 1, numeroFra: 1, fechaFact: 1, nombreCiudad: 1, tipoGen: 1, agno: 1, mes: 1,
                  descrClaseServ: '$detalleFact.descrClaseServ', descripcionServicio: '$detalleFact.descripcionServicio',
                  valorAntesImptos: {
                      $let: {
                          vars: {valorTipo: '$detalleFact.valor', tipo: '$detalleFact.tipo'},
                          in: { $cond: { if: { $eq: [ "$$tipo", "SF" ] }, then: "$$valorTipo", else: 0 } }
                      }
                  },
                  valorIF: {
                      $let: {
                          vars: {valorTipo: '$detalleFact.valor', tipo: '$detalleFact.tipo'},
                          in: { $cond: { if: { $eq: [ "$$tipo", "IF" ] }, then: "$$valorTipo", else: 0 } }
                      }
                  }
                }},
                {$group: {_id: {contrato: '$contrato', numeroFra: '$numeroFra', fechaFact: '$fechaFact',
                    nombreCiudad: '$nombreCiudad', tipoGen: '$tipoGen', agno: '$agno', mes: '$mes',
                    descripcionServicio: '$descripcionServicio', descrClaseServ: '$descrClaseServ'},
                    valorAntesImptos: {$sum: '$valorAntesImptos'}, valorIF: {$sum: '$valorIF'}}},
                {$project: {_id: {$concat: ['$_id.contrato', '$_id.numeroFra',
                    '$_id.descripcionServicio', '$_id.descrClaseServ']},
                    contrato: '$_id.contrato', numeroFra: '$_id.numeroFra', fechaFact: '$_id.fechaFact',
                    nombreCiudad: '$_id.nombreCiudad', tipoGen: '$_id.tipoGen', agno: '$_id.agno', mes: '$_id.mes',
                    nombreZona: '$_id.descripcionServicio', descrRecurso: '$_id.descrClaseServ',
                    valorAntesImptos: {$toLong: '$valorAntesImptos'}, valorFactura: {$toLong: '$valorIF'},
                    valorFacturado: {$toLong: {$add: [ '$valorAntesImptos', '$valorIF' ]}}}},
                {$sort: {_id: 1}},
                
                {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}},
                {$unwind: "$cliente"},
                {$project: {_id: 1, contrato: 1, numeroFra: 1, fechaFact: 1, nombreCliente: '$cliente.nombreCliente',
                    apellidoCliente: '$cliente.apellidoCliente', nombreBarrio: '$cliente.descrEstrato',
                    nombreCiudad: 1, tipoGen: 1, agno: 1, mes: 1, nombreZona: 1, descrRecurso: 1,
                    valorAntesImptos: 1, valorFactura: 1, valorFacturado: 1}},
              ]`}
              // console.log(this.props.permiteOpcion1, opciones1, this.props.empresa.empresaArchFE, argsBuscarFact)
            }else{
              argsBuscarFact = {tipoqry: `[{$match: ${argsBuscarFact}},{$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}}]`}
              // console.log(this.props.permiteOpcion1, opciones1, this.props.empresa.empresaArchFE, argsBuscarFact)
            }
          }
        }else{
          // console.log("11")
          let tipoqry = `[{$match: ${argsBuscarFact}},`
          // let tipoqry = `[{$match: {contrato: '10653'}},`
          if(this.props.permiteOpcion1&&opciones1==="opcion7"){
            argsBuscarFact = {tipoqry: `${tipoqry}
              {$unwind: "$detalleFact"},
              {$project: {contrato: 1, descrClaseServ: '$detalleFact.descrClaseServ',
                  valorAntesImptos: {
                      $let: {
                          vars: {valorTipo: '$detalleFact.valor', tipo: '$detalleFact.tipo'},
                          in: { $cond: { if: { $eq: [ "$$tipo", "SF" ] }, then: "$$valorTipo", else: 0 } }
                      }
                  },
                  valorIF: {
                      $let: {
                          vars: {valorTipo: '$detalleFact.valor', tipo: '$detalleFact.tipo'},
                          in: { $cond: { if: { $eq: [ "$$tipo", "IF" ] }, then: "$$valorTipo", else: 0 } }
                      }
                  }
              }},
              {$group: {_id: {contrato: '$contrato', descrClaseServ: '$descrClaseServ'},
                  valorAntesImptos: {$sum: '$valorAntesImptos'}, valorIF: {$sum: '$valorIF'}}},
              {$project: {_id: {$concat: ['$_id.contrato', '$_id.descrClaseServ']}, contrato: '$_id.contrato',
                  descrRecurso: '$_id.descrClaseServ',
                  valorAntesImptos: {$toLong: '$valorAntesImptos'}, valorFactura: {$toLong: '$valorIF'},
                  valorFacturado: {$toLong: {$add: [ '$valorAntesImptos', '$valorIF' ]}}}},
              {$sort: {_id: 1}},
              {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}}
            ]`}
          }
          if(this.props.permiteOpcion1&&opciones1==="opcion8"){
            argsBuscarFact = {tipoqry: `${tipoqry}
              {$unwind:'$detalleFact'},
              {$match: {'detalleFact.tipo': "SF"}},
              {$project: {'codigoServicio': '$detalleFact.codigoServicio',
                  'descripcionServicio': '$detalleFact.descripcionServicio',
                  'valorProceso': {
                      $let: {
                          vars: {valorTipo: '$detalleFact.valor', tipo: '$tipoGen'},
                          in: { $cond: { if: { $eq: [ "$$tipo", "proceso" ] }, then: "$$valorTipo", else: 0 } }
                      }
                  },
                  'valorMes': {
                      $let: {
                          vars: {valorTipo: '$detalleFact.valor', tipo: '$tipoGen'},
                          in: { $cond: { if: { $eq: [ "$$tipo", "mes" ] }, then: "$$valorTipo", else: 0 } }
                      }
                  }
              }},
              {$group: {_id: {codigoServicio: '$codigoServicio', descripcionServicio: '$descripcionServicio'},
                              valorProceso: {$sum: '$valorProceso'}, valorMes: {$sum: '$valorMes'}}},
              {$lookup: {from: 'servicios', localField: '_id.codigoServicio', foreignField: 'codigoServicio', as: 'servicio'}},
              {$project: {_id: 0, 'codigoServicio': '$_id.codigoServicio', 'descripcionServicio': '$_id.descripcionServicio',
                  valorProceso: {$toLong: '$valorProceso'}, valorMes: {$toLong: '$valorMes'},
                  'servicio': {
                      $cond: { if: { $eq: [ { $size: '$servicio' }, 0 ] },
                          then: [{subclaseserv: {descrSubclaseServ: "$_id.descripcionServicio", claseserv: {descrClaseServ: "$_id.descripcionServicio"}}}],
                          else: "$servicio"} 
                  },
              }},
              {$unwind:'$servicio'},
              {$project: {_id: {$concat: ['$codigoServicio', '$descripcionServicio', '$servicio.subclaseserv.descrSubclaseServ', '$servicio.subclaseserv.claseserv.descrClaseServ']},
                  direccion: '$codigoServicio', nombreZona: '$descripcionServicio',
                  valorAntesImptos: '$valorProceso', valorFacturado: '$valorMes',
                  nombreCiudad: "$servicio.subclaseserv.descrSubclaseServ",
                  descrDpto: "$servicio.subclaseserv.claseserv.descrClaseServ"
              }}
            ]`}
          }
        }

        // console.log(argsBuscarFact)
        if(argsBuscarFact){
          let {data} = await this.props.allFactRtes.refetch(argsBuscarFact)
          clientesFact = await data.allFactRtes
        }
      }
      
      // console.log(argsBuscarFact)
      // console.log(clientesFact)

//Se comenta para incluir todas las facturas => se incluyen las de impto = 0
      // if(this.props.permiteOpcion2&&this.state.opciones1!=="opcion6"){
      //   clientesFact = clientesFact.filter(elemento => elemento.valorFacturado>elemento.valorAntesImptos)
      // }

// console.log(argsDocum)
// console.log(this.state.opciones1)


      let listRtes = [], totalF = 0, totalAI = 0, totalI = 0, totalFdo = 0, totalSA = 0, totalEF = 0
      // console.log(clientesFact)
      // console.log(movimRdo)
      // console.log(this.state.argsSelDpto)  
          // console.log(listRtes)

          if(this.state.opciones1==="opcion5"){
            let clientesFactTF = _(clientesFact)
              .groupBy('numeroFra')
              .map((obj, key) => ({
                  'numeroFra': key
                }))
              .value()
              totalF = clientesFactTF.length
          }


          clientesFact.forEach((elemento, _id) => {
            let nombreCliente = "", apellidoCliente = "", codigoTipoDoc = "", numeroDoc = ""
            if(this.state.opciones1==="opcion6"){
              if(this.props.permiteOpcion1){
                totalF = totUsu
              }else{
                totalF += elemento.totServ
              }
              totalAI += elemento.valorSF
              totalI += elemento.valorIF
              totalFdo += elemento.valorSF + elemento.valorIF
            }else{
              if(this.state.opciones1!=="opcion7"&&this.state.opciones1!=="opcion8"){
                if(!elemento.nombreCliente){
                  // const indexLis = this.props.allClientes.allClientes.findIndex(cliente => cliente.contrato === elemento.contrato);
                  // if(indexLis!==1){
                    // console.log(elemento.contrato)
                  if(elemento.cliente[0]){
                    nombreCliente = elemento.cliente[0].nombreCliente
                    apellidoCliente = elemento.cliente[0].apellidoCliente
                    codigoTipoDoc = elemento.cliente[0].tipodoc.codigoTipoDoc
                    numeroDoc = elemento.cliente[0].numeroDoc
                  }
                }else{
                  // console.log(elemento)
                  nombreCliente = elemento.nombreCliente
                  apellidoCliente = elemento.apellidoCliente
                  if(this.state.opciones1!=="opcion5"){
                    codigoTipoDoc = elemento.cliente[0].tipodoc.codigoTipoDoc
                    numeroDoc = elemento.cliente[0].numeroDoc
                  }
                }
                totalAI += elemento.valorAntesImptos
                if(this.state.opciones1==="opcion5"){
                  totalI += elemento.valorFactura
                }else{
                  totalF += 1
                  totalI += (elemento.valorFacturado - elemento.valorAntesImptos)
                }
                // totalFdo += elemento.valorFacturado
                // totalSA += (elemento.valorFactura - elemento.valorFacturado)
                // totalEF += elemento.valorFactura
                totalEF += (elemento.valorAntesImptos + elemento.valorFactura)
              }
            }
            if(this.state.opciones1==="opcion4"){
              totalFdo += elemento.valorFacturado
              argsUpd = {}
              argsUpd = {
                "fechaFact": elemento.fechaFact,
                "numeroFra": elemento.numeroFra,
                "nombreCiudad": elemento.nombreCiudad,
                "contrato": elemento.contrato,
                "nombreCliente": nombreCliente,
                "apellidoCliente": apellidoCliente,
                "codigoTipoDoc": codigoTipoDoc,
                "numeroDoc": numeroDoc,
                "tipoGen": elemento.tipoGen,
                "agno": elemento.agno,
                "mes": elemento.mes,
                "valorAntesImptos": elemento.valorAntesImptos,
                "valorFacturado": elemento.valorFacturado,
                "valorFactura": elemento.valorFactura,
              }
              listRtes.push(argsUpd)
            }
            if(this.state.opciones1!=="opcion4"&&this.state.opciones1!=="opcion6"&&
                this.state.opciones1!=="opcion7"&&this.state.opciones1!=="opcion8"&&
                this.props.permiteOpcion1){
              // elemento.detalleFact.forEach((elemento2, i) => {
                if(this.state.opciones1==="opcion5"){
                  totalFdo += elemento.valorFacturado
                  argsUpd = {}
                  argsUpd = {
                    "fechaFact": elemento.fechaFact,
                    "numeroFra": elemento.numeroFra,
                    "nombreCiudad": elemento.nombreCiudad,
                    "contrato": elemento.contrato,
                    "nombreCliente": elemento.nombreCliente,
                    "apellidoCliente": elemento.apellidoCliente,
                    "tipoGen": elemento.tipoGen,
                    "agno": elemento.agno,
                    "mes": elemento.mes,
                    "descrClaseServ": elemento.descrRecurso,
                    "descripcionServicio": elemento.nombreZona,
                    "descrEstrato": elemento.nombreBarrio,
                    "valorAntesImptos": elemento.valorAntesImptos,
                    "valorFactura": elemento.valorFactura,
                    "valorFacturado": elemento.valorFacturado,
                  }
                  listRtes.push(argsUpd)
                }
              // })
            }
            if(this.state.opciones1!=="opcion4"&&this.state.opciones1!=="opcion6"&&this.state.opciones1!=="opcion7"&&
                this.props.permiteOpcion2){
              elemento.detalleFact.forEach((elemento2, i) => {
                totalFdo += elemento2.valor
                if(elemento2.tipo==="IF"){
                  if(this.state.opciones1==="opcion5"){
                    argsUpd = {}
                    argsUpd = {
                      "fechaFact": elemento.fechaFact,
                      "numeroFra": elemento.numeroFra,
                      "nombreCiudad": elemento.nombreCiudad,
                      "contrato": elemento.contrato,
                      "nombreCliente": nombreCliente,
                      "apellidoCliente": apellidoCliente,
                      "tipoGen": elemento.tipoGen,
                      "agno": elemento.agno,
                      "mes": elemento.mes,
                      "descripcionServicio": elemento2.descripcionServicio,
                      "concepto": elemento2.concepto,
                      "valor": elemento2.valor,
                    }
                  }
                  listRtes.push(argsUpd)
                }
              })
            }
            if(this.state.opciones1==="opcion6"){
              argsUpd = {}
              if(this.props.permiteOpcion1){
                argsUpd = {
                  "descrClaseServ": elemento.descrClaseServ,
                  "descripcionServicio": elemento.descripcionServicio,
                  "concepto": elemento.concepto,
                  "valor": elemento.valorSF + elemento.valorIF,
                }
              }else{
                argsUpd = {
                  "descrClaseServ": elemento.descrClaseServ,
                  "descripcionServicio": elemento.descripcionServicio,
                  "valorSF": elemento.valorSF,
                  "valorIF": elemento.valorIF,
                  "valorTot": elemento.valorSF + elemento.valorIF,
                  "totServ": elemento.totServ
                }
              }
              listRtes.push(argsUpd)
            }
            if(this.props.permiteOpcion1&&this.state.opciones1==="opcion7"){
              // console.log("22")
              //TOTAL POR CONTRATO
              let direccionCli = ""
              // console.log(elemento)
              if(elemento.cliente[0].direccion&&elemento.cliente[0].direccion.descrTipoVia1){
                direccionCli = elemento.cliente[0].direccion.descrTipoVia1?elemento.cliente[0].direccion.descrTipoVia1:""
                direccionCli += elemento.cliente[0].direccion.numeroTipoVia1?" " + elemento.cliente[0].direccion.numeroTipoVia1:""
                direccionCli += elemento.cliente[0].direccion.descrTipoVia2?" " + elemento.cliente[0].direccion.descrTipoVia2:""
                direccionCli += elemento.cliente[0].direccion.numeroTipoVia2?" " + elemento.cliente[0].direccion.numeroTipoVia2:""
                direccionCli += elemento.cliente[0].direccion.numeroTipoVia2F?" " + elemento.cliente[0].direccion.numeroTipoVia2F:""
                direccionCli += elemento.cliente[0].direccion.descrTipoUnd1?" " + elemento.cliente[0].direccion.descrTipoUnd1:""
                direccionCli += elemento.cliente[0].direccion.numeroTipoUnd1?" " + elemento.cliente[0].direccion.numeroTipoUnd1:""
                direccionCli += elemento.cliente[0].direccion.descrTipoUnd2?" " + elemento.cliente[0].direccion.descrTipoUnd2:""
                direccionCli += elemento.cliente[0].direccion.numeroTipoUnd2?" " + elemento.cliente[0].direccion.numeroTipoUnd2:""
              }
              let razonSocial = elemento.cliente[0].nombreCliente + " " + elemento.cliente[0].apellidoCliente
              argsUpd = {}
              argsUpd = {
                "contrato": elemento.contrato,
                "codigoTipoDoc": elemento.cliente[0].tipodoc.codigoTipoDoc,
                "numeroDoc": elemento.cliente[0].numeroDoc,
                "apellidoCliente": elemento.cliente[0].apellidoCliente,
                "nombreCliente": elemento.cliente[0].nombreCliente,
                "razonSocial": razonSocial,
                "direccionCli": direccionCli,
                "nombreBarrio": elemento.cliente[0].dirmayor&&elemento.cliente[0].dirmayor.codigoDpto?elemento.cliente[0].dirmayor.ciudades.zonas.barrios.nombreBarrio:"",
                "codigoDpto": elemento.cliente[0].dirmayor&&elemento.cliente[0].dirmayor.codigoDpto?elemento.cliente[0].dirmayor.codigoDpto:"",
                "codigoCiudad": elemento.cliente[0].dirmayor&&elemento.cliente[0].dirmayor.codigoDpto?elemento.cliente[0].dirmayor.ciudades.codigoCiudad:"",
                "descrEstrato": elemento.cliente[0].descrEstrato,
                "descrClaseServ": elemento.descrRecurso,
                "valorAntesImptos": elemento.valorAntesImptos,
                "valorImptos": elemento.valorFactura,
                "valorFacturado": elemento.valorFacturado,
              }
              totalFdo += elemento.valorFacturado
              totalI += (elemento.valorFacturado - elemento.valorAntesImptos)

              listRtes.push(argsUpd)
            }
            if(this.props.permiteOpcion1&&this.state.opciones1==="opcion8"){
              argsUpd = {}
              argsUpd = {
                "descrClaseServ": elemento.descrDpto,
                "descrSubclaseServ": elemento.nombreCiudad,
                "descripcionServicio": elemento.nombreZona,
                "valorProceso": elemento.valorAntesImptos,
                "valorMes": elemento.valorFacturado,
              }
              totalFdo += elemento.valorAntesImptos
              totalI += elemento.valorFacturado
      
              listRtes.push(argsUpd)
            }
            if(this.props.permiteOpcion2&&this.state.opciones1==="opcion7"){
              //TOTAL CON/SIN impto
              argsUpd = {}
              argsUpd = {
                "descrClaseServ": elemento.descrRecurso,
                "valorFacturado": elemento.valorFacturado,
                "valorAntesImptos": elemento.valorAntesImptos,
              }
              totalAI += elemento.valorAntesImptos
              totalFdo += (elemento.valorAntesImptos + elemento.valorFacturado)
              totalI += elemento.valorFacturado

              listRtes.push(argsUpd)
            }
          })
// console.log(listRtes)

          this.setState({listRtes})
          this.setState({totalF, totalAI, totalI, totalFdo, totalSA, totalEF, totUsu})
      }
    }
    // console.log(targetName)
    // console.log(this.props.permiteOpcion2)

    if(targetName==="pdf"){
      let doc = {}
      let left = 10
      let right = 10
      if((this.state.opciones1==="opcion6")||(this.props.permiteOpcion2&&this.state.opciones1==="opcion7")){
        doc = new jsPDF({orientation: 'p', unit: 'mm', format: 'letter'})
        left = 20
        right = 20
      }else{
        doc = new jsPDF({orientation: 'l', unit: 'mm', format: 'letter'})
      }
      // var doc = new jsPDF({orientation: 'l', unit: 'mm', format: 'letter'})

      let texto1 = this.props.empresa.empresaRazonSocial
      let texto2 = "FACTURACION " + argsDocum.desde + " A " + argsDocum.hasta
      if(this.props.argsSelDpto.descrClaseServ&&this.props.argsSelDpto.descrClaseServ!=="Todas..."){
        texto2 = "FACTURACION " + argsDocum.desde + " A " + argsDocum.hasta + " - " + this.props.argsSelDpto.descrClaseServ
      }

      // const fechaHoy = new Date()
      // let agnoHoy = fechaHoy.getFullYear()
      // let mesHoy = ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1))
      // mesHoy = agnoHoy + "-" + mesHoy
      // let mesMsg = ""
      // argsDocum.mes?mesMsg=argsDocum.mes:mesMsg=mesHoy
      // let tit1Texto3 = argsDocum.desde
      // let tit2Texto3 = argsDocum.hasta
      // let texto3 = `${tit1Texto3} - ${tit2Texto3}`
      let widthDoc = (doc.internal.pageSize.width)

      doc.setFontSize(18);
      doc.setFontType("bold");
      doc.text(texto1, widthDoc/2, 20, 'center')
      doc.setFontSize(14);
      doc.text(texto2, widthDoc/2, 30, 'center')

      let movColecc = [], argsUpd = [], longMayor = 0

      let texto3 = ""
      // if((this.props.permiteOpcion1||this.props.permiteOpcion2)&&this.state.opciones1==="opcion6"){
      if((this.state.opciones1==="opcion6")||(this.props.permiteOpcion2&&this.state.opciones1==="opcion7")){
        if(this.props.argsSelDpto.descrDpto===undefined||this.props.argsSelDpto.descrDpto==="Todos..."){
          // clientesLis = clientesLis
        }else{
          if(this.props.argsSelDpto.nombreCiudad===undefined||this.props.argsSelDpto.nombreCiudad==="Todas..."){
            texto3 = this.props.argsSelDpto.descrDpto
          }else{
            texto3 = this.props.argsSelDpto.descrDpto + " - " + this.props.argsSelDpto.nombreCiudad
          }
        }
      }
      let linY = 45
      if(this.props.permiteOpcion2&&(this.state.opciones1==="opcion6"||this.state.opciones1==="opcion7")){
        let texto4 = ""
        if(this.state.opciones1==="opcion6"){
          texto4 = "USUARIOS: " + general.formatNum(this.state.totUsu.toString())
        }
        if(texto3){
          linY = 55
          doc.text(texto3, widthDoc/2, 40, 'center')
          doc.text(texto4, widthDoc/2, 50, 'center')
        }else{
          doc.text(texto4, widthDoc/2, 40, 'center')
        }

        this.state.listRtes.forEach((elemento, i) => {
          if(elemento.descrClaseServ.length>longMayor){
            longMayor = elemento.descrClaseServ.length
          }
          if(this.state.opciones1==="opcion6"){
            argsUpd = [elemento.descrClaseServ, elemento.descripcionServicio,
              general.formatNum(elemento.valorSF.toString()),
              general.formatNum(elemento.valorIF.toString()),
              general.formatNum(elemento.valorTot.toString())]
          }
          if(this.state.opciones1==="opcion7"){
            argsUpd = [elemento.descrClaseServ,
              general.formatNum(elemento.valorAntesImptos.toString()),
              general.formatNum(elemento.valorFacturado.toString()),
              general.formatNum((elemento.valorAntesImptos + elemento.valorFacturado).toString())]
          }

          movColecc.push(argsUpd)
        })
        let espacios = ""
        for(let ii=0; ii<longMayor; ii++){espacios += " "}
        let encab
        if(this.state.opciones1==="opcion6"){
          argsUpd = ["", espacios + "TOTALES:",
            general.formatNum(this.state.totalAI.toString()),
            general.formatNum(this.state.totalI.toString()),
            general.formatNum(this.state.totalFdo.toString())]

          encab = ["Clase", "Servicio", {content: "$ Antes imptos", styles: {halign: "right"}},
            {content: "$ Impuestos", styles: {halign: "right"}},
            {content: "$ Tot Facturado", styles: {halign: "right"}}]
        }
        if(this.state.opciones1==="opcion7"){
          argsUpd = [espacios + "TOTALES:",
            general.formatNum(this.state.totalAI.toString()),
            general.formatNum(this.state.totalI.toString()),
            general.formatNum(this.state.totalFdo.toString())]
          encab = ["Clase", {content: "$ Antes imptos", styles: {halign: "right"}},
            {content: "$ Impuestos", styles: {halign: "right"}},
            {content: "$ Tot Facturado", styles: {halign: "right"}}]
        }
        movColecc.push(argsUpd)

        doc.autoTable({startY: linY,
          tableLineColor: "blue",
          tableLineWidth: 0.1,
          styles: {
            // font: 'Calibri',
            fontSize: 10,
            lineColor: "black",
            lineWidth: 0.1
          },
          headStyles: {
            fillColor: "#bdc3c7",
            textColor: "black",
            fontSize: 12
          },
          bodyStyles: {
            fillColor: "#E9E4F0",
            textColor: "black"
          },
          alternateRowStyles: {
            fillColor: "white",
            textColor: "black"
          },
          columnStyles: 
            this.state.opciones1==="opcion6"?
              {
                2: {halign: "right"},
                3: {halign: "right"},
                4: {halign: "right"},
                5: {halign: "right"}
              }:
              {
                1: {halign: "right"},
                2: {halign: "right"},
                3: {halign: "right"}
              },
          footStyles: {
            fillColor: "#bdc3c7",
            textColor: "black",
            fontSize: 9
          },
          head: [encab],
          body: movColecc,
          // foot: foot,
          // margin: {top: 0, left: 10, right: 66},})
          margin: {top: 10, left: left, right: right},})  
  
        // let finalY = doc.previousAutoTable.finalY; //para traer posicion final de la tabla
        // doc.text("TOTALES" + general.formatNum(this.state.totalAI.toString()), 150, finalY + 15);
        // doc.text("USUARIOS" + general.formatNum(this.state.totalF.toString()), 150, finalY + 30);

        // let nameDoc = `facturas.pdf`
        // doc.autoPrint({variant: 'non-conform'});
        // doc.save(nameDoc)
      }
      if(this.props.permiteOpcion1&&this.state.opciones1==="opcion6"){
        let texto4 = "TOTAL FACTURAS: " + general.formatNum(this.state.totalF.toString())
        if(texto3){
          linY = 55
          doc.text(texto3, widthDoc/2, 40, 'center')
          doc.text(texto4, widthDoc/2, 50, 'center')
        }else{
          doc.text(texto4, widthDoc/2, 40, 'center')
        }

        this.state.listRtes.forEach((elemento, i) => {
          if(elemento.concepto.length>longMayor){
            longMayor = elemento.concepto.length
          }
          argsUpd = [elemento.descrClaseServ, elemento.descripcionServicio, elemento.concepto,
            general.formatNum(elemento.valor.toString())]
          movColecc.push(argsUpd)
        })
        let espacios = ""
        for(let ii=0; ii<longMayor; ii++){espacios += " "}
        argsUpd = ["", "", espacios + "TOTAL:",
          general.formatNum(this.state.totalFdo.toString())]
        movColecc.push(argsUpd)

        doc.autoTable({startY: linY,
          tableLineColor: "blue",
          tableLineWidth: 0.1,
          styles: {
            // font: 'Calibri',
            fontSize: 10,
            lineColor: "black",
            lineWidth: 0.1
          },
          headStyles: {
            fillColor: "#bdc3c7",
            textColor: "black",
            fontSize: 12
          },
          bodyStyles: {
            fillColor: "#E9E4F0",
            textColor: "black"
          },
          alternateRowStyles: {
            fillColor: "white",
            textColor: "black"
          },
          columnStyles: {
            3: {halign: "right"},
          },
          footStyles: {
            fillColor: "#bdc3c7",
            textColor: "black",
            fontSize: 9
          },
          head: [["Clase", "Servicio", "Concepto", {content: "$ Valor", styles: {halign: "right"}}]],
          body: movColecc,
          // foot: foot,
          // margin: {top: 0, left: 10, right: 66},})
          margin: {top: 10, left: left, right: right},})  
      }
      if((this.state.opciones1!=="opcion6")&&!(this.props.permiteOpcion2&&this.state.opciones1==="opcion7")){
        if(texto3){
          linY = 55
          doc.text(texto3, widthDoc/2, 40, 'center')
        }

        var source = document.getElementById("tabla");
        doc.autoTable({startY: linY,
                        tableLineColor: "blue",
                        tableLineWidth: 0.1,
                        styles: {
                          // font: 'Calibri',
                          fontSize: 10,
                          lineColor: "black",
                          lineWidth: 0.1
                        },
                        headStyles: {
                          fillColor: "#bdc3c7",
                          textColor: "black",
                          fontSize: 12
                        },
                        bodyStyles: {
                          fillColor: "#E9E4F0",
                          textColor: "black"
                        },
                        alternateRowStyles: {
                          fillColor: "white",
                          textColor: "black"
                        },
                        html: source,
                        margin: {top: 10, left: left, right: right},})  

        // doc.autoPrint({variant: 'non-conform'});
        // doc.output('dataurlnewwindow'); //abre el pdf en una nueva ventana
        // // doc.save('facturas.pdf')
      }

      let nameDoc = `facturacion.pdf`
      doc.autoPrint({variant: 'non-conform'});
      doc.save(nameDoc)

      // doc.autoPrint({variant: 'non-conform'});
      // doc.output('dataurlnewwindow'); //abre el pdf en una nueva ventana

    }

    if(targetName==="excel"){
      let xlsString = []
      let listRtes = this.state.listRtes
// console.log(listRtes)
      let xlsString1 = []
      if(opciones1==="opcion4"&&this.props.permiteOpcion1){
        if(filtroCiu){
          xlsString1 = ['Fecha Fra', '# Factura', 'Ciudad', 'Contrato', 'Nombre(s)', 'Apellido(s)', 'Tipo Doc', '# Doc', 'Generada en',
          'Mes', '$ antes imptos', '$ impuestos', '$ Facurado', '$ Saldo ant', '$ Total fra']
        }else{
          xlsString1 = ['Fecha Fra', '# Factura', 'Contrato', 'Nombre(s)', 'Apellido(s)', 'Tipo Doc', '# Doc', 'Generada en',
          'Mes', '$ antes imptos', '$ impuestos', '$ Facurado', '$ Saldo ant', '$ Total fra']
        }
      }
      if(opciones1==="opcion4"&&this.props.permiteOpcion2){
        if(filtroCiu){
          xlsString1 = ['Fecha Fra', '# Factura', 'Ciudad', 'Contrato', 'Nombre(s)', 'Apellido(s)', 'Generada en',
            'Mes', '$ antes imptos', '$ impuestos', '$ Facurado']
        }else{
          xlsString1 = ['Fecha Fra', '# Factura', 'Contrato', 'Nombre(s)', 'Apellido(s)', 'Generada en',
            'Mes', '$ antes imptos', '$ impuestos', '$ Facurado']
        }
      }
      if(opciones1==="opcion5"){
        if(filtroCiu){
          xlsString1 = ['Fecha Fra', '# Factura', 'Ciudad', 'Contrato', 'Nombre(s)', 'Apellido(s)', 'Estrato', 'Generada en',
            'Mes', 'Clase', 'Servicio', '$ Antes Imptos', '$ Imptos', '$ Facturado']
        }else{
          xlsString1 = ['Fecha Fra', '# Factura', 'Contrato', 'Nombre(s)', 'Apellido(s)', 'Estrato', 'Generada en',
            'Mes', 'Clase', 'Servicio', '$ Antes Imptos', '$ Imptos', '$ Facturado']
        }
      }
      if(this.props.permiteOpcion1&&opciones1==="opcion6"){
        xlsString1 = ['Clase', 'Servicio', 'Concepto', '$ Valor']
      }
      if(this.props.permiteOpcion2&&opciones1==="opcion6"){
        xlsString1 = ['Clase', 'Servicio', '$ Antes imptos', '$ Impuestos', '$ Tot Facturado']
      }
      if(this.props.permiteOpcion1&&opciones1==="opcion7"){
        xlsString1 = ['CONTRATO', 'TIPO DOCUM', 'No. DOCUM', 'APELLIDO(S)', 'NOMBRE(S)', 'RAZON SOCIAL', 'DIRECCION',
        'BARRIO', 'DPTO', 'CIUDAD', 'ESTRATO', 'CLASE', 'ANTES DE IMPTOS', 'IMPUESTOS', 'FACTURADO']
      }
      if(this.props.permiteOpcion1&&opciones1==="opcion8"){
        xlsString1 = ['CLASE', 'SUBCLASE', 'SERVICIO', 'VALOR PROCESO', 'VALOR MES']
      }
      if(this.props.permiteOpcion2&&opciones1==="opcion7"){
        xlsString1 = ['Clase', '$ Antes imptos', '$ Impuestos', '$ Tot Facturado']
      }

      xlsString.push(xlsString1)

      for(let i=0; i<listRtes.length; i++){
        let fechaFact = "", valor = 0, valorSF = 0, valorIF = 0, valorTot = 0
        if(listRtes[i].fechaFact){
          fechaFact = new Date(listRtes[i].fechaFact)
          let horaPago = (fechaFact.getUTCHours()<10?'0'+fechaFact.getUTCHours():fechaFact.getUTCHours())+":"+(fechaFact.getUTCMinutes()<10?'0'+fechaFact.getUTCMinutes():fechaFact.getUTCMinutes())+":"+(fechaFact.getUTCSeconds()<10?'0'+fechaFact.getUTCSeconds():fechaFact.getUTCSeconds());
          fechaFact = (fechaFact.getUTCFullYear()) + '-' +
            ((fechaFact.getUTCMonth()+1)<10?'0'+(fechaFact.getUTCMonth()+1):(fechaFact.getUTCMonth()+1)) + '-' +
            (fechaFact.getUTCDate()<10?'0'+fechaFact.getUTCDate():fechaFact.getUTCDate())

          if(horaPago==="00:00:00"){
            fechaFact = new Date(fechaFact + 'T23:00:00.000Z')
          }else{
            fechaFact = new Date(fechaFact + 'T' + horaPago + 'Z')
          }
        }
        if(listRtes[i].valor){
          valor = listRtes[i].valor
        }
        if(listRtes[i].valorSF){
          valorSF = listRtes[i].valorSF
        }
        if(listRtes[i].valorIF){
          valorIF = listRtes[i].valorIF
        }
        if(listRtes[i].valorTot){
          valorTot = listRtes[i].valorTot
        }

        if(opciones1==="opcion4"&&this.props.permiteOpcion1){
          let mes = listRtes[i].agno + '-' + listRtes[i].mes
          let impuestos = listRtes[i].valorFacturado - listRtes[i].valorAntesImptos
          let saldoAnt = listRtes[i].valorFactura - listRtes[i].valorFacturado
          if(filtroCiu){
            xlsString1 = [fechaFact, listRtes[i].numeroFra, listRtes[i].nombreCiudad, listRtes[i].contrato,
              listRtes[i].nombreCliente, listRtes[i].apellidoCliente, listRtes[i].codigoTipoDoc, listRtes[i].numeroDoc, listRtes[i].tipoGen,
              mes, listRtes[i].valorAntesImptos, impuestos, listRtes[i].valorFacturado,
              saldoAnt, listRtes[i].valorFactura]
          }else{
            xlsString1 = [fechaFact, listRtes[i].numeroFra, listRtes[i].contrato,
              listRtes[i].nombreCliente, listRtes[i].apellidoCliente, listRtes[i].codigoTipoDoc, listRtes[i].numeroDoc, listRtes[i].tipoGen,
              mes, listRtes[i].valorAntesImptos, impuestos, listRtes[i].valorFacturado,
              saldoAnt, listRtes[i].valorFactura]
          }
        }
        if(opciones1==="opcion4"&&this.props.permiteOpcion2){
          let mes = listRtes[i].agno + '-' + listRtes[i].mes
          let impuestos = listRtes[i].valorFacturado - listRtes[i].valorAntesImptos
          if(filtroCiu){
            xlsString1 = [fechaFact, listRtes[i].numeroFra, listRtes[i].nombreCiudad, listRtes[i].contrato,
              listRtes[i].nombreCliente, listRtes[i].apellidoCliente, listRtes[i].tipoGen,
              mes, listRtes[i].valorAntesImptos, impuestos, listRtes[i].valorFacturado]
          }else{
            xlsString1 = [fechaFact, listRtes[i].numeroFra, listRtes[i].contrato,
              listRtes[i].nombreCliente, listRtes[i].apellidoCliente, listRtes[i].tipoGen,
              mes, listRtes[i].valorAntesImptos, impuestos, listRtes[i].valorFacturado]
          }
        }
        if(opciones1==="opcion5"){
          let mes = listRtes[i].agno + '-' + listRtes[i].mes
          if(filtroCiu){
            xlsString1 = [fechaFact, listRtes[i].numeroFra, listRtes[i].nombreCiudad, listRtes[i].contrato,
              listRtes[i].nombreCliente, listRtes[i].apellidoCliente, listRtes[i].descrEstrato,
              listRtes[i].tipoGen, mes, listRtes[i].descrClaseServ, listRtes[i].descripcionServicio,
              listRtes[i].valorAntesImptos, listRtes[i].valorFactura, listRtes[i].valorFacturado]
          }else{
            xlsString1 = [fechaFact, listRtes[i].numeroFra, listRtes[i].contrato,
              listRtes[i].nombreCliente, listRtes[i].apellidoCliente, listRtes[i].descrEstrato,
              listRtes[i].tipoGen, mes, listRtes[i].descrClaseServ, listRtes[i].descripcionServicio,
              listRtes[i].valorAntesImptos, listRtes[i].valorFactura, listRtes[i].valorFacturado]
          }
        }
        if(this.props.permiteOpcion1&&opciones1==="opcion6"){
          xlsString1 = [listRtes[i].descrClaseServ, listRtes[i].descripcionServicio,
            listRtes[i].concepto, valor]
        }
        if(this.props.permiteOpcion2&&opciones1==="opcion6"){
          xlsString1 = [listRtes[i].descrClaseServ, listRtes[i].descripcionServicio,
          valorSF, valorIF, valorTot]
        }
        if(this.props.permiteOpcion1&&opciones1==="opcion7"){
          // let valorImptos = parseInt(listRtes[i].valorFacturado, 10) - parseInt(listRtes[i].valorAntesImptos, 10)
          xlsString1 = [listRtes[i].contrato, listRtes[i].codigoTipoDoc, listRtes[i].numeroDoc,
            listRtes[i].apellidoCliente, listRtes[i].nombreCliente,
            listRtes[i].razonSocial, listRtes[i].direccionCli, listRtes[i].nombreBarrio, 
            listRtes[i].codigoDpto, listRtes[i].codigoCiudad, listRtes[i].descrEstrato,
            listRtes[i].descrClaseServ,
            listRtes[i].valorAntesImptos, listRtes[i].valorImptos, listRtes[i].valorFacturado]
        }
        if(this.props.permiteOpcion1&&opciones1==="opcion8"){
          xlsString1 = [listRtes[i].descrClaseServ, listRtes[i].descrSubclaseServ,
            listRtes[i].descripcionServicio,
            listRtes[i].valorProceso, listRtes[i].valorMes]
        }
        if(this.props.permiteOpcion2&&opciones1==="opcion7"){
          let valorFdo = parseInt(listRtes[i].valorAntesImptos, 10) + parseInt(listRtes[i].valorFacturado, 10)
          xlsString1 = [listRtes[i].descrClaseServ, listRtes[i].valorAntesImptos, listRtes[i].valorFacturado, valorFdo]
        }

    // console.log(xlsString1)
        xlsString.push(xlsString1)
      }
  // console.log(xlsString)

      var wb = XLSX.utils.book_new();

      wb.Props = {
        Title: "SheetJS Tutorial",
        Subject: "Test",
        Author: "Red Stapler",
        CreatedDate: new Date(2017,12,19)
      };

      wb.SheetNames.push("Facturacion");

      let ws_data = xlsString;

      let ws = XLSX.utils.aoa_to_sheet(ws_data);
      wb.Sheets["Facturacion"] = ws;
      let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
      function s2ab(s) { 
        let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
        let view = new Uint8Array(buf);  //create uint8array as viewer
        for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
        return buf;    
      }
      saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'facturacion.xlsx');
//FIN Exportar a XLS
    }
    document.body.style.cursor = 'default'

    // console.log("listooooo")
  }
  
  componentDidUpdate(prevProps, prevState){
    if(this.props.argsSelDpto.codigoCiudad!==undefined&&this.props.argsSelDpto.codigoCiudad!==""){
      let miLista = document.getElementById("miLista1");
      if(miLista&&miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoCiudad){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreCiudad'] = "Todas..."
        argsSelDpto['codigoCiudad'] = ""
        argsSelDpto['codigoCiudadInterno'] = ""
        argsSelDpto['codBarrasRdo'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.descrDpto!==this.state.argsDocum.descrDpto||
        this.props.argsSelDpto.nombreCiudad!==this.state.argsDocum.nombreCiudad){
      const argsDocum = this.state.argsDocum
      argsDocum.descrDpto = this.props.argsSelDpto.descrDpto
      argsDocum.nombreCiudad = this.props.argsSelDpto.nombreCiudad
      this.setState({argsDocum});
      this.setState({argsSelDpto: this.props.argsSelDpto})
      let listRtes = []
      this.setState({listRtes, totalF: 0, totalAI: 0, totalI: 0, totalFdo: 0, totalSA: 0, totalEF: 0, totUsu: 0})
      this.setState({verEnPantalla: false})
    }

    // console.log(this.state.opciones1, prevState.opciones1, this.state.listRtes.length, prevState.listRtes.length)
    // console.log(this.props.argsSelDpto)
    // console.log(prevProps.argsSelDpto)
    let opci1 = document.getElementsByName("opciones1")
    // console.log(opci1[0].checked, this.state.opciones1)
    if(opci1[0].checked&&this.state.opciones1!=="opcion4"){
    // if(this.state.opciones1===prevState.opciones1&&this.state.opciones1!=="opcion4"&&
    //     (!this.state.verEnPantalla||(this.state.listRtes.length===0&&prevState.listRtes.length>0))){
      // console.log("111", this.state.verEnPantalla)
      this.setState({opciones1: "opcion4"})
      let listRtes = []
      this.setState({listRtes, totalF: 0, totalAI: 0, totalI: 0, totalFdo: 0, totalSA: 0, totalEF: 0, totUsu: 0})
    }
    // if(this.props.argsSelDpto!==prevProps.argsSelDpto){
    //   this.setState({argsSelDpto: this.props.argsSelDpto})
    //   let listRtes = []
    //   this.setState({listRtes, totalF: 0, totalAI: 0, totalI: 0, totalFdo: 0, totalSA: 0, totalEF: 0, totUsu: 0})
    //   this.setState({verEnPantalla: false})
    // }
    if(this.props.permiteOpcion1!==prevProps.permiteOpcion1||this.props.permiteOpcion2!==prevProps.permiteOpcion2){
      let listRtes = []
      this.setState({listRtes})
    }
  }

  shouldComponentUpdate(nextProps){
    // console.log(this.props.permiteOpcion1, nextProps.permiteOpcion1)
    // console.log(this.props.permiteOpcion2, nextProps.permiteOpcion2)
    if(this.props.permiteOpcion1!==nextProps.permiteOpcion1||this.props.permiteOpcion2!==nextProps.permiteOpcion2){
      let listRtes = []
      this.setState({listRtes})
      return false
    }else{
      return true
    }
  }

  componentWillUnmount(){
    let listRtes = []
    this.setState({listRtes, totalF: 0, totalAI: 0, totalI: 0, totalFdo: 0, totalSA: 0, totalEF: 0, totUsu: 0})
    this.setState({verEnPantalla: false})
  }

  render(){
    const {argsDocum, opciones, opciones1, listRtes, confirmaAct, errors, totalF, totalAI,
      totalI, totalFdo, totalSA, totalEF, totUsu, verEnPantalla} = this.state;

    if(this.props.codigoCiudadUA!=="Todas..."){
      let dpto = document.getElementById("miLista");
      if(dpto){
        dpto.options.selectedIndex = 0
      }
    }

    let colecc = selciudad(this.props.list3, this.props.argsSelDpto, this.props.codigoCiudadUA)
    let listCiu = colecc.listCiu

    // let fechaHoy = new Date()
    // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
    // console.log(opciones1, this.props.permiteOpcion2)
// console.log(this.props.allClientes.allClientes)
    // console.log(this.props.allFactRtes.allFactRtes)
// console.log(this.props.list1)
// console.log(this.props.argsSelDpto)
// console.log(argsDocum)
// console.log(opciones, opciones1)

// let valorTotal = Intl.NumberFormat().format(valorTot)
// let totalPagos = Intl.NumberFormat().format(totPag)

// console.log(argsDocum._id)
let procesosFact = []
if(argsDocum._id!=="Todos..."){
  // console.log(this.props.list1)
  this.props.list1.forEach((elemento, i) => {
    // console.log(elemento)
    // console.log(argsDocum)
    // if(elemento.fechaFact.substr(0, 10))
    if(this.props.codigoCiudadUA!=="Todas..."){
      if(elemento.idRangoFact===argsDocum._id&&elemento.fechaFact>=argsDocum.desde&&
          elemento.fechaFact<=argsDocum.hasta&&elemento.descrDpto===this.props.argsSelDpto.descrDpto&&
          elemento.nombreCiudad===this.props.argsSelDpto.nombreCiudad){
        procesosFact.push(elemento)
      }
    }else{
      if(elemento.idRangoFact===argsDocum._id&&elemento.fechaFact>=argsDocum.desde&&
        elemento.fechaFact<=argsDocum.hasta){
        procesosFact.push(elemento)
      }
    }
  })
}else{
  // console.log(this.props.list1)
  this.props.list1.forEach((elemento, i) => {
    if(this.props.codigoCiudadUA!=="Todas..."){
      if(elemento.fechaFact>=argsDocum.desde&&elemento.fechaFact<=argsDocum.hasta&&
        elemento.descrDpto===this.props.argsSelDpto.descrDpto&&
        elemento.nombreCiudad===this.props.argsSelDpto.nombreCiudad){
        procesosFact.push(elemento)
      }
    }else{
      if(elemento.fechaFact>=argsDocum.desde&&elemento.fechaFact<=argsDocum.hasta){
        procesosFact.push(elemento)
      }
    }
  })

  // procesosFact = this.props.list1
}
procesosFact = _.orderBy(procesosFact, ['_id'], ['desc'])

// this.props.list1.forEach((elemento, i) => {
//   if(elemento.fechaCreate.substr(0, 10)>=argsDocum.desdeF&&elemento.fechaCreate.substr(0, 10)<=argsDocum.hastaF){
//     procesosFact.push(elemento)
//   }
// })

let titOpcion = "Facturación"
if(this.props.permiteOpcion2){
  titOpcion = "Impuestos"
}
let factOServ = "Facturas"
if(this.props.permiteOpcion2&&opciones1==="opcion6"){
  factOServ = "Servicios"
}
let totalF1 = Intl.NumberFormat('de-DE').format(totalF)
let totalAI1 = Intl.NumberFormat('de-DE').format(totalAI)
let totalI1 = Intl.NumberFormat('de-DE').format(totalI)
let totalFdo1 = Intl.NumberFormat('de-DE').format(totalFdo)
let totalSA1 = Intl.NumberFormat('de-DE').format(totalSA)
let totalEF1 = Intl.NumberFormat('de-DE').format(totalEF)
let totUsu1 = Intl.NumberFormat('de-DE').format(totUsu)

// console.log(listRtes)
// console.log(procesosFact)
// console.log(this.props.list3)
// console.log(this.props.permiteOpcion1)
// console.log(this.props.permiteOpcion2)
// console.log(opciones1)
    let filtroCiu = false
    if(this.props.list3.length<2){
      this.props.list3.forEach((elemento, i) => {
        if(elemento.ciudades.length>1){
          filtroCiu = true
        }
      })
    }else{
      filtroCiu = true
    }

    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large money yellow icon"></i>
          {titOpcion}
        </button>

        <div>
          <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
            <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, argsDocum, opciones, opciones1, filtroCiu):()=>{}}>
              <div>
                <div className="ui three column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '20%'}}>
                      <h1 style={{color: '#2C7744'}}>{titOpcion}</h1>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      {this.props.permiteOpcion1 &&
                        <fieldset><legend style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;&nbsp;&nbsp;Tipo de reporte&nbsp;&nbsp;&nbsp;</legend>
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion4" defaultChecked="true" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;General&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion5" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Detallado&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion6" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Total&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion7" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Total por contrato&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion8" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Total por servicio</label>
                        </fieldset>
                      }
                      {this.props.permiteOpcion2 &&
                        <fieldset><legend style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;&nbsp;&nbsp;Tipo de reporte&nbsp;&nbsp;&nbsp;</legend>
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion4" defaultChecked="true" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;General&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion5" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Detallado&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion6" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Total&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion7" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Total CON/SIN impto</label>
                        </fieldset>
                      }
                    </div>
                    <div className="column" style={{width: '30%'}}>
                      <fieldset><legend style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;&nbsp;&nbsp;Causado en&nbsp;&nbsp;&nbsp;</legend>
                        <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion1" defaultChecked="true" onChange={this.handleChange}></input>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Todo&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                        <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion2" onChange={this.handleChange}></input>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Mes&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                        <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion3" onChange={this.handleChange}></input>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Proceso fact</label>
                      </fieldset>
                    </div>

                  </div>
                </div>
                {/* <hr></hr>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '25%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Procesos fact desde
                      </p>
                      <Form.Field>
                        <input style={this.props.styles.input} type='date' name="desdeF" id="desdeF" value={argsDocum.desdeF} onChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '25%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Hasta
                      </p>
                      <Form.Field>
                        <input style={this.props.styles.input} type='date' name="hastaF" id="hastaF" value={argsDocum.hastaF} onChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                  </div>
                </div> */}
                <hr></hr>
                <div className="ui three column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Rango de facturación
                      </p>
                      <Form.Field>
                        <ListaRango styles={this.props.styles} list={this.props.list} handleChange={this.handleChange} />
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '25%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Facturas causadas desde
                      </p>
                      <Form.Field>
                        <input style={this.props.styles.input} type='date' name="desde" id="desde" value={argsDocum.desde} onChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '25%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Hasta
                      </p>
                      <Form.Field>
                        <input style={this.props.styles.input} type='date' name="hasta" id="hasta" value={argsDocum.hasta} onChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                  </div>
                </div>

                <hr></hr>
                <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                  Procesos de facturación
                </p>
                <Form.Field>
                  <ListaPF styles={this.props.styles} list={procesosFact} handleChange={this.handleChange}/>
                </Form.Field>

                {((opciones1==="opcion6")||(this.props.permiteOpcion2&&opciones1==="opcion7")) &&
                  <div>
                    <hr></hr>
                    <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      Clase
                    </p>
                    <Form.Field>
                      <Lista styles={this.props.styles} list={this.props.list2} handleLista4={this.props.handleLista4}  argsSelDpto={this.props.argsSelDpto} handleChange={this.handleChange}/>
                    </Form.Field>
                  </div>
                }
                {filtroCiu &&
                  <div>
                    <hr></hr>
                    <div className="ui two column stackable grid">
                      <div className="row container">
                        <div className="column" style={{width: '50%'}}>
                          <Form.Field>
                            <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                              Departamento
                            </label>
                            <ListaDe list={this.props.list3} styles={this.props.styles}
                              handleLista={this.props.handleLista}
                              codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}/>
                          </Form.Field>
                        </div>
                        <div className="column" style={{width: '50%'}}>
                          <Form.Field>
                            <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                              Ciudad
                            </label>
                            <ListaCi list={listCiu} styles={this.props.styles}
                            handleLista1={this.props.handleLista1} argsSelDpto={this.props.argsSelDpto}
                            codigoCiudadUA={this.props.codigoCiudadUA}/>
                          </Form.Field>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                <hr></hr>
                <hr></hr>

                {(this.props.permiteOpcion1&&opciones1!=="opcion5"&&opciones1!=="opcion6"&&opciones1!=="opcion7"&&opciones1!=="opcion8") &&
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Totales:&nbsp;&nbsp;{factOServ}:&nbsp;
                    {totalF1}&nbsp;&nbsp;&nbsp;&nbsp;
                    Antes de impuestos:&nbsp;
                    {totalAI1}&nbsp;&nbsp;&nbsp;&nbsp;
                    Impuestos:&nbsp;
                    {totalI1}&nbsp;&nbsp;&nbsp;&nbsp;
                    Total facturado:&nbsp;
                    {totalFdo1}&nbsp;&nbsp;&nbsp;&nbsp;
                    {/* Total saldo anterior:&nbsp;
                    {totalSA1}&nbsp;&nbsp;&nbsp;&nbsp; */}
                    Total en factura:&nbsp;
                    {totalEF1}
                  </p>
                }
                {(this.props.permiteOpcion1&&opciones1==="opcion5") &&
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Totales:&nbsp;&nbsp;{factOServ}:&nbsp;
                    {totalF1}&nbsp;&nbsp;&nbsp;&nbsp;
                    Antes de impuestos:&nbsp;
                    {totalAI1}&nbsp;&nbsp;&nbsp;&nbsp;
                    Impuestos:&nbsp;
                    {totalI1}&nbsp;&nbsp;&nbsp;&nbsp;
                    Total facturado:&nbsp;
                    {totalFdo1}&nbsp;&nbsp;&nbsp;&nbsp;
                  </p>
                }
                {/* {(this.props.permiteOpcion2&&opciones1!=="opcion6") &&
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Totales:&nbsp;&nbsp;{factOServ}:&nbsp;
                    {totalF1}&nbsp;&nbsp;&nbsp;&nbsp;
                    Antes de impuestos:&nbsp;
                    {totalAI1}&nbsp;&nbsp;&nbsp;&nbsp;
                    Impuestos:&nbsp;
                    {totalI1}&nbsp;&nbsp;&nbsp;&nbsp;
                    Total facturado:&nbsp;
                    {totalFdo1}&nbsp;&nbsp;&nbsp;&nbsp;
                  </p>
                } */}
                {/* {(this.props.permiteOpcion2&&opciones1!=="opcion6")||(this.props.permiteOpcion1&&opciones1==="opcion6") && */}
                {((this.props.permiteOpcion2&&opciones1!=="opcion6"&&opciones1!=="opcion7"&&opciones1!=="opcion8")||
                      (this.props.permiteOpcion1&&opciones1==="opcion6")) &&
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Totales:&nbsp;&nbsp;{factOServ}:&nbsp;
                    {totalF1}&nbsp;&nbsp;&nbsp;&nbsp;
                    Antes de impuestos:&nbsp;
                    {totalAI1}&nbsp;&nbsp;&nbsp;&nbsp;
                    Impuestos:&nbsp;
                    {totalI1}&nbsp;&nbsp;&nbsp;&nbsp;
                    Total facturado:&nbsp;
                    {totalFdo1}&nbsp;&nbsp;&nbsp;&nbsp;
                  </p>
                }
                {(this.props.permiteOpcion2&&opciones1==="opcion6") &&
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Totales:&nbsp;&nbsp;Antes de impuestos:&nbsp;
                    {totalAI1}&nbsp;&nbsp;&nbsp;&nbsp;
                    Impuestos:&nbsp;
                    {totalI1}&nbsp;&nbsp;&nbsp;&nbsp;
                    Total facturado:&nbsp;
                    {totalFdo1}&nbsp;&nbsp;&nbsp;&nbsp;
                    Usuarios:&nbsp;
                    {totUsu1}&nbsp;&nbsp;&nbsp;&nbsp;
                  </p>
                }
                {(this.props.permiteOpcion1&&opciones1==="opcion7") &&
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Totales:&nbsp;&nbsp;
                    Facturado:&nbsp;
                    {totalFdo1}&nbsp;&nbsp;&nbsp;&nbsp;
                    Impuestos:&nbsp;
                    {totalI1}&nbsp;&nbsp;&nbsp;&nbsp;
                  </p>
                }
                {(this.props.permiteOpcion1&&opciones1==="opcion8") &&
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Totales antes de IVA:&nbsp;&nbsp;
                    Fact Proceso:&nbsp;
                    {totalFdo1}&nbsp;&nbsp;&nbsp;&nbsp;
                    Fact Mes:&nbsp;
                    {totalI1}&nbsp;&nbsp;&nbsp;&nbsp;
                  </p>
                }
                {(this.props.permiteOpcion2&&opciones1==="opcion7") &&
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Totales:&nbsp;&nbsp;Antes de impuestos:&nbsp;
                    {totalAI1}&nbsp;&nbsp;&nbsp;&nbsp;
                    Impuestos:&nbsp;
                    {totalI1}&nbsp;&nbsp;&nbsp;&nbsp;
                    Total facturado:&nbsp;
                    {totalFdo1}&nbsp;&nbsp;&nbsp;&nbsp;
                  </p>
                }

                <div className="ui three column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '34%'}}>
                      <Button id="pantalla" name="pantalla" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum, opciones, opciones1)} fluid>
                        VER EN PANTALLA
                      </Button>
                    </div>
                    <div className="column" style={{width: '33%'}}>
                      <Button id="excel" name="excel" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum, opciones, opciones1)} fluid>
                        ARCHIVO EXCEL
                      </Button>
                    </div>
                    <div className="column" style={{width: '33%'}}>
                      <Button id="pdf" name="pdf" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum, opciones, opciones1)} fluid>
                        ARCHIVO PDF
                      </Button>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <div style={{height: '40em', overflow: 'auto'}}>

                {(opciones1==="opcion4"&&this.props.permiteOpcion1) &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className='right aligned'>Fecha Fra</th>
                        <th className='right aligned'># Factura</th>
                        {filtroCiu &&
                          <th className='right aligned'>Ciudad</th>
                        }
                        <th className='right aligned'>Contrato</th>
                        <th className='right aligned'>Nombre</th>
                        <th className='right aligned'>Apellido</th>
                        <th className='right aligned'>Tipo Doc</th>
                        <th className='right aligned'># Doc</th>
                        <th className='right aligned'>Generada en</th>
                        <th className='right aligned'>Mes</th>
                        <th className='right aligned'>$ antes imptos</th>
                        <th className='right aligned'>$ impuestos</th>
                        <th className='right aligned'>$ Facurado</th>
                        <th className='right aligned'>$ Saldo ant</th>
                        <th className='right aligned'>$ Total fra</th>
                      </tr>
                    </thead>
                    {verEnPantalla &&
                      <ListaFact list={listRtes} opciones1={opciones1} filtroCiu={filtroCiu}
                        permiteOpcion1={this.props.permiteOpcion1} permiteOpcion2={this.props.permiteOpcion2}/>
                    }
                  </table>
                }
                {(opciones1==="opcion4"&&this.props.permiteOpcion2) &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className='right aligned'>Fecha Fra</th>
                        <th className='right aligned'># Factura</th>
                        {filtroCiu &&
                          <th className='right aligned'>Ciudad</th>
                        }
                        <th className='right aligned'>Contrato</th>
                        <th className='right aligned'>Nombre</th>
                        <th className='right aligned'>Apellido</th>
                        <th className='right aligned'>Generada en</th>
                        <th className='right aligned'>Mes</th>
                        <th className='right aligned'>$ antes imptos</th>
                        <th className='right aligned'>$ impuestos</th>
                        <th className='right aligned'>$ Facurado</th>
                      </tr>
                    </thead>
                    {verEnPantalla &&
                      <ListaFact list={listRtes} opciones1={opciones1} filtroCiu={filtroCiu}
                        permiteOpcion1={this.props.permiteOpcion1} permiteOpcion2={this.props.permiteOpcion2}/>
                    }
                  </table>
                }
                {opciones1==="opcion5" &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className='right aligned'>Fecha Fra</th>
                        <th className='right aligned'># Factura</th>
                        {filtroCiu &&
                          <th className='right aligned'>Ciudad</th>
                        }
                        <th className='right aligned'>Contrato</th>
                        <th className='right aligned'>Nombre</th>
                        <th className='right aligned'>Apellido</th>
                        <th className='right aligned'>Estrato</th>
                        <th className='right aligned'>Generada en</th>
                        <th className='right aligned'>Mes</th>
                        <th className='right aligned'>Clase</th>
                        <th className='right aligned'>Servicio</th>
                        <th className='right aligned'>$ antes imptos</th>
                        <th className='right aligned'>$ impuestos</th>
                        <th className='right aligned'>$ Facurado</th>
                      </tr>
                    </thead>
                    {verEnPantalla &&
                      <ListaFact list={listRtes} opciones1={opciones1} filtroCiu={filtroCiu}
                        permiteOpcion1={this.props.permiteOpcion1} permiteOpcion2={this.props.permiteOpcion2}/>
                    }
                  </table>
                }
                {(this.props.permiteOpcion1&&opciones1==="opcion6") &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className='right aligned'>Clase</th>
                        <th className='right aligned'>Servicio</th>
                        <th className='right aligned'>Concepto</th>
                        <th className='right aligned'>$ Valor</th>
                      </tr>
                    </thead>
                    {verEnPantalla &&
                      <ListaFact list={listRtes} opciones1={opciones1} filtroCiu={filtroCiu}
                        permiteOpcion1={this.props.permiteOpcion1} permiteOpcion2={this.props.permiteOpcion2}/>
                    }
                  </table>
                }
                {this.props.permiteOpcion2&&opciones1==="opcion6" &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className='right aligned'>Clase</th>
                        <th className='right aligned'>Servicio</th>
                        <th className='right aligned'>$ Antes imptos</th>
                        <th className='right aligned'>$ Impuestos</th>
                        <th className='right aligned'>$ Tot Facturado</th>
                        {/* <th className='right aligned'># Servicios</th> */}
                      </tr>
                    </thead>
                    {verEnPantalla &&
                      <ListaFact list={listRtes} opciones1={opciones1} filtroCiu={filtroCiu}
                        permiteOpcion1={this.props.permiteOpcion1} permiteOpcion2={this.props.permiteOpcion2}/>
                    }
                  </table>
                }
                {this.props.permiteOpcion1&&opciones1==="opcion7" &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className=''>CONTRATO</th>
                        <th className=''>TIPO DOCUM</th>
                        <th className=''>No. DOCUM</th>
                        <th className=''>APELLIDO(S)</th>
                        <th className=''>NOMBRE(S)</th>
                        <th className=''>RAZON SOCIAL</th>
                        <th className=''>DIRECCION</th>
                        <th className=''>BARRIO</th>
                        <th className=''>DPTO</th>
                        <th className=''>CIUDAD</th>
                        <th className=''>ESTRATO</th>
                        <th className=''>CLASE</th>
                        <th className='right aligned'>ANTES DE IMPTOS</th>
                        <th className='right aligned'>IMPUESTOS</th>
                        <th className='right aligned'>FACTURADO</th>
                      </tr>
                    </thead>
                    {verEnPantalla &&
                      <ListaFact list={listRtes} opciones1={opciones1} filtroCiu={filtroCiu}
                        permiteOpcion1={this.props.permiteOpcion1} permiteOpcion2={this.props.permiteOpcion2}/>
                    }
                  </table>
                }
                {this.props.permiteOpcion1&&opciones1==="opcion8" &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className=''>CLASE</th>
                        <th className=''>SUBCLASE</th>
                        <th className=''>SERVICIO</th>
                        <th className='right aligned'>TOTAL PROCESO</th>
                        <th className='right aligned'>TOTAL MES</th>
                      </tr>
                    </thead>
                    {verEnPantalla &&
                      <ListaFact list={listRtes} opciones1={opciones1} filtroCiu={filtroCiu}
                        permiteOpcion1={this.props.permiteOpcion1} permiteOpcion2={this.props.permiteOpcion2}/>
                    }
                  </table>
                }
                {this.props.permiteOpcion2&&opciones1==="opcion7" &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className='right aligned'>Clase</th>
                        <th className='right aligned'>$ Antes imptos</th>
                        <th className='right aligned'>$ Impuestos</th>
                        <th className='right aligned'>$ Tot Facturado</th>
                      </tr>
                    </thead>
                    {verEnPantalla &&
                      <ListaFact list={listRtes} opciones1={opciones1} filtroCiu={filtroCiu}
                        permiteOpcion1={this.props.permiteOpcion1} permiteOpcion2={this.props.permiteOpcion2}/>
                    }
                  </table>
                }
                </div>
              </div>
              
              {
                errors.length?<Message negative header="Los siguientes errores:"
                list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
              }

            </Form>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  // graphql(queries.query.allClientes, {name:'allClientes', options: (props) => {return {variables: argsBuscarCL}}}),
  // graphql(queries.query.allFactRtes, {name:'allFactRtes', options: (props) => {return {variables: {fechaMov: { $gte: "2019-04-08", $lte: "2019-04-08" }}}}}),
  graphql(queries.query.allFactRtes, {name:'allFactRtes', options: (props) => {return {variables: argsBuscarFact}}}),
  graphql(queries.query.allFactRtesGroup, {name:'allFactRtesGroup', options: (props) => {return {variables: argsBuscarFactGr}}}),

  )(RtesFact2)
